import catchErrors from './catchErrors'
import api from '@/config/api'
import vuex from '@/store'
import { fixtureMacros } from '@/services/__fixtures__/macros'

const MOCK_ENABLED = import.meta.env.VITE_AGENT_GATEWAY_MOCK === 'true'

export default {
  dispatchCommand(stationId, type, payload) {
    return catchErrors.post(`/v2/stations/${stationId}/agent/commands`, { type, payload })
  },

  getMacros(platformId) {
    if (MOCK_ENABLED) return Promise.resolve({ data: fixtureMacros })
    return catchErrors.get(`/v2/platforms/${platformId}/macros`)
  },

  executeMacro(macroId) {
    if (MOCK_ENABLED) return Promise.resolve({ data: { success: true } })
    return catchErrors.post(`/v2/macros/${macroId}/execute`)
  },

  getPlatforms(params = {}) {
    const station = encodeURIComponent(vuex.getters.currentStation.station)
    return catchErrors.get(`/v2/newsdesk/stations/${station}/platforms`, { params })
  },

  getPlatform(platformId) {
    return catchErrors.get(`/v2/newsdesk/platforms/${platformId}`)
  },

  addPlatform(data) {
    const station = encodeURIComponent(vuex.getters.currentStation.station)
    return api.post(`/v2/newsdesk/stations/${station}/platforms`, data)
  },

  updatePlatform(id, data) {
    return api.patch(`/v2/newsdesk/platforms/${id}`, data)
  },

  deletePlatform(id) {
    return api.delete(`/v2/newsdesk/platforms/${id}`)
  },

  async deletePlatforms(ids = []) {
    return catchErrors.delete(`/v2/newsdesk/platforms`, {
      params: { ids },
      cache: { maxAge: 0, exclude: { query: true } }
    })
  },

  getPlatformOptions() {
    const station = encodeURIComponent(vuex.getters.currentStation.station)
    return api.get(`/v2/newsdesk/stations/${station}/platforms/options`, {
      cache: { maxAge: 0, ignoreCache: true }
    })
  },

  getAdminPlatforms(params = {}) {
    return api.get(`/v2/newsdesk/admin/platforms`, {
      params,
      cache: { maxAge: 0, ignoreCache: true }
    })
  },

  addAdminPlatform(data) {
    return api.post(`/v2/newsdesk/admin/platforms`, data)
  },

  updateAdminPlatform(id, data) {
    return api.patch(`/v2/newsdesk/admin/platforms/${id}`, data)
  },

  deleteAdminPlatform(id, params = {}) {
    return api.delete(`/v2/newsdesk/admin/platforms/${id}`, {
      params,
      cache: { maxAge: 0, exclude: { query: true } }
    })
  },

  async deleteAdminPlatforms(ids = [], params = {}) {
    return catchErrors.delete(`/v2/newsdesk/admin/platforms`, {
      params: { ids, ...params },
      cache: { maxAge: 0, exclude: { query: true } }
    })
  },

  getAdminPlatformOptions() {
    return api.get(`/v2/newsdesk/admin/platforms/options`, {
      cache: { maxAge: 0, ignoreCache: true }
    })
  },

  getSequencesPlatforms(params = {}) {
    const station = encodeURIComponent(vuex.getters.currentStation.station)
    return api.get(`/v2/newsdesk/platforms/${station}`, {
      params,
      cache: { maxAge: 0, ignoreCache: true }
    })
  },
  searchPlatformCmsTaxonomy(platformId, type, query = '') {
    const station = encodeURIComponent(vuex.getters.currentStation.station)
    return api.get(`/v2/newsdesk/stations/${station}/platforms/${platformId}/cms-taxonomy`, {
      params: { type, query },
      cache: { maxAge: 0, ignoreCache: true }
    })
  },
  getPlatformCmsMetadata(platformId) {
    const station = encodeURIComponent(vuex.getters.currentStation.station)
    return api.get(`/v2/newsdesk/stations/${station}/platforms/${platformId}/cms-metadata`, {
      cache: { maxAge: 0, ignoreCache: true }
    })
  },
  refreshPlatformCmsMetadata(platformId) {
    const station = encodeURIComponent(vuex.getters.currentStation.station)
    return api.post(`/v2/newsdesk/stations/${station}/platforms/${platformId}/cms-metadata/refresh`)
  }
}
